import React from "react";
import style from "./style";

const FakeMyProducts = () => {
  return (
    <div className="faker-commercial-area">
      <div className="skeleton title" />
      <div className="banners">
        <div className="skeleton banner width-50" />
        <div className="skeleton banner width-50" />
        <div />
      </div>
      <div className="skeleton title" />
      <div className="banners">
        <div className="skeleton banner width-50" />
        <div className="skeleton banner width-50" />
      </div>
      <style jsx>{style}</style>
    </div>
  );
};

export default FakeMyProducts;
